module.exports = __webpack_public_path__ + "img/nodeType3.7635103d.svg";